/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompositionProductVariantSummaryDTO {
  brandEquity?: number;
  brandId?: number;
  brandName?: string;
  category?: string;
  categoryExternalId?: number;
  categoryExternalIdString?: string;
  categoryId?: number;
  categoryLevel?: number;
  categoryName?: string;
  cean?: string;
  cfop?: string;
  compositionId?: number;
  compositionName?: string;
  compositionVariantId?: number;
  costPrice?: number;
  cst?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  description?: string;
  displayTitle?: string;
  editionId?: number;
  editionName?: string;
  expiration?: string;
  externalId?: string;
  externalStoreUrl?: string;
  extipi?: string;
  genero?: string;
  inStock?: number;
  internalEAN?: string;
  invoiceName?: string;
  invoicePrice?: number;
  isSellableUrl?: boolean;
  longExternalStoreUrl?: string;
  maxSubscriberCount?: number;
  maxTradesPerPerson?: number;
  movementDate?: Date;
  ncm?: string;
  orderCount?: number;
  personId?: number;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  salePrice?: number;
  saleStock?: number;
  sellable?: boolean;
  shippingOrderTypeId?: number;
  shippingOrderTypeName?: string;
  subscriberId?: number;
  subscriptionId?: number;
  tradeActive?: boolean;
  tradeCount?: number;
  tradePoints?: number;
  tradeStock?: number;
  tradeable?: boolean;
  unitMeasure?: number;
  unitName?: string;
  variantSummary?: string;
  weight?: number;
  weightGrams?: number;
}
